module.exports = __webpack_public_path__ + "static/media/JP_RCH_EYELASHES02.d0d8902f.jpg";